module.exports = __webpack_public_path__ + "img/image1.5c3e5edf.jpg";